import { atom } from 'recoil';

export const newAppointmentUtilityStateAtom = atom({
  key: 'newAppointmentUtilityStateAtom',
  default: {
    open: false,
  },
});
